import ReactRailsUJS from 'react_ujs'

export const mountReactComponentsOnTurboLoad = () => {
  // To remount frontend components with Turbo Drive
  window.addEventListener('turbo:load', function () {
    ReactRailsUJS?.mountComponents()
  })
}
